import React, { useContext } from 'react';

import { Link as RouterLink } from 'react-router-dom';

import {
    Accordion,
    AccordionDetails,
    AccordionSummary, Link, Table,
    TableBody,
    TableCell, TableHead, TableRow, Typography
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { NavContext } from "../../../contexts";

import { StoricoUfficioComuneCompetenzaContext } from '../StoricoUfficioComuneCompetenzaContext';

const LinkRouter = props => <Link {...props} component={RouterLink} />;

export const EccezioniList = ({
                                   disabled,
                                   formRef,
                                   onActionClick,
                                   ...props }) => {

    const {
        getRouteTo,
        navigateTo,
    } = useContext(NavContext);

    const {
        state,
        setState,
    } = useContext(StoricoUfficioComuneCompetenzaContext);

    const {
        storicoUfficioComuneCompetenza
    } = state;

    const buildTableCellRowComponent = (key, value, oldValue) => {
        return (<TableRow>
            <TableCell style={{ width: "20%" }}>
                {key}
            </TableCell>
            <TableCell>
                <div>
                    {value ?? '-'}
                </div>
                {( value != oldValue ? <div style={{
                    //backgroundColor: 'rgba(255, 0, 0, 0.6)',
                    textDecoration: 'line-through',
                    color: 'red'
                }}>
                    {oldValue ?? '-'}
                </div> : <div />)}
            </TableCell>
        </TableRow>);
    }

    return (
        <>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                    aria-controls="ufficio-panel"
                    id="ufficio-panel"
                    sx={{
                        color: "white",
                        backgroundColor: "secondary.main",
                    }}
                >
                    <Typography variant="h6">Eccezioni</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: 0 }}>
                    <Table>
                        <TableBody>
                            {
                                storicoUfficioComuneCompetenza && storicoUfficioComuneCompetenza.valore.Eccezioni?.length > 0 && storicoUfficioComuneCompetenza.valore.Eccezioni.map((eccezione, index) =>
    <TableRow>
        <TableCell style={{ width: "20%" }}>
            Nome ufficio
        </TableCell>
        <TableCell>
            <div>
                {eccezione.Ufficio?.Nome}
            </div>
        </TableCell>
    </TableRow>

                                )
                            }
                        </TableBody>
                    </Table>
                </AccordionDetails>
            </Accordion>
        </>
    );
}